<template>
  <div id="content">
    <h1>Configurações</h1>

    <nav class="settings__menu">
      <ul>
        <li
          :class="{ ativo: component == 'Profile' }"
          @click="changeTab('Profile')"
        >
          Perfil
        </li>
        <li
          :class="{ ativo: component == 'Account' }"
          @click="changeTab('Account')"
        >
          Dados Pessoais
        </li>
        <li :class="{ ativo: component == 'Bank' }" @click="changeTab('Bank')">
          Conta
        </li>
        <!-- <li
          :class="{ 'ativo': component == 'Bank'}"
          @click="changeTab('Bank')"
        >
          Banco
        </li> -->
      </ul>
    </nav>

    <component :is="component" />
  </div>
</template>


<script>
import Profile from './components/profile.vue';
import Account from './components/account.vue';
import Bank from './components/bank.vue';

export default {
  name: 'Settings',

  components: {
    Profile,
    Account,
    Bank,
  },

  data() {
    return {
      teacher: {
        nome: '',
        sobrenome: '',
        profissao: '',
        telefone: '',
        email: '',

        senhaAtual: '',
        novaSenha: '',
        repetirSenha: '',
      },
      component: 'Profile',
    };
  },

  methods: {
    salvar() {
      console.log(this.teacher);
    },

    changeTab(component) {
      this.component = component;
    },
  },
};
</script>


<style lang="scss" scoped>
.settings__menu ul {
  list-style: none;
  display: flex;
}

.settings__menu ul li {
  margin-right: 45px;
  padding: 15px;
  font-weight: 700;
  font-size: 1rem;
  color: #3a3b3f;
  letter-spacing: -0.05px;
  margin-bottom: 24px;
  cursor: pointer;
}

.settings__menu ul li.ativo {
  border-bottom: 3px solid #1d43ff;
}
</style>